import axios from "axios";

// Use environment variable for baseURL
const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

export const GetPosts = async () => await API.get("/post/");
export const CreatePost = async (data) => await API.post("/post/", data);
export const DeletePost = async (id) => await API.delete(`/post/${id}`);
export const GenerateImageFromPrompt = async (data) =>
  await API.post("/generateImage/", data);
export const SendUserSignupToN8n = async (data) =>
  await API.post("/user/signup", data);
export const SendUserSigninToN8n = async (data) =>
  await API.post("/user/signin", data);
